import type { FunctionComponent, PropsWithChildren } from 'react';

import { ButtonVariant } from '../controls/button/Button';
import { BlockingModalContent } from '../popup/content/BlockingModalContent';

import { ErrorBoundary } from './ErrorBoundary';

export const FinalErrorBoundary: FunctionComponent<PropsWithChildren> = ({ children }) => {
  return (
    <ErrorBoundary
      fallback={
        <BlockingModalContent
          messageTk={'Please contact Customer Support for assistance'}
          actions={[
            {
              tk: 'OK',
              type: ButtonVariant.ACCENT,
              click: (): void => {
                location.reload();
              },
            },
          ]}
          inCurtain
        />
      }
      critical
    >
      {children}
    </ErrorBoundary>
  );
};
